import { SET_PRIVELEGED_RESPONSE } from '../actions/privelegedAccountActions';

const initialState = null

const privelegedResponseReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_PRIVELEGED_RESPONSE:
        return action.payload;
      default:
        return state;
    }
  };
  
  export default privelegedResponseReducer;
  